import { fun_PostAction, fun_Download } from "@/api/index";
// 引入公共方法
import {fun_DownloadFile, fun_GetKeys} from "@/utils/validate";
import CaLock from "@/components/common/calock";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        tenderCorpName: null, // 招标人
        tenderAgentOrganName: null, // 招标代理
        tenderClassNum: null, // 招标类别
        regulators: null, // 监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "监管部门：",
          value: "regulators",
          placeholder: "请输入",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "input",
          label: "招标人：",
          value: "tenderCorpName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "招标代理：",
          value: "tenderAgentOrganName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "招标类别：",
          value: "tenderClassNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201510200918460003"
          },
        },

      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "300",
          fixed: true,
          isShow: true
        },
        {
          label: "标段号",
          prop: "section",
          width: "80",
          fixed: true
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
          fixed: true,
          width: "130",
        },
        {
          label: "申请状态",
          slotName: "state",
          fixed: true,
          width: "130",
        },
        {
          label: "终止类型",
          slotName: "terminationType",
          fixed: true,
          width: "130",
        },
        {
          label: "终止节点",
          prop: "terminationNodeName",
          width: "130",
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: "230"
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "150",
        },
        {
          label: "招标联系电话",
          prop: "tenderLinkPhone",
          width: "130"
        },
        {
          label: "招标监管部门",
          prop: "regulatorsName",
          width: "300"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。",
         }*/
       ],
      // 表头按钮组
      btnList: [
        {
          name: "提出终止申请",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 如果用户标识是工作人员或者监管人员
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员" || this.userFlag === "分包合同监管人员") {
      // 清空表头
      this.btnList = [];
    }
    // 默认打开项目评审列表
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/tenderTermination/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },

    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "提出终止申请":
          // 跳转路由
          this.$router.push({
            path: "/tenderTerminationDetail",
            query: {
              controllerFlag: "insert"
            }
          });
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },

    /**
     * 点击修改按钮
     * @author 滕威
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 记录专家状态判断是否能删除
          var count = 0;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 不是自行组织
          if (tenderMethod && tenderMethod !== "1" && tenderCorpFlag === "01") {
            // 提示
            this.$alert("该项目为委托招标请联系招标代理做修改操作。", "warning");
            return;
          }
          // 判断状态为通过或提交
          if (this.multipleSelection[0].state === "tj" || this.multipleSelection[0].state === "tg") {
            // 提示
            this.$alert("选中数据存在已提交或通过的终止申请，不能修改！", "warning");
            return;
          }
          // 跳转路由
          this.$router.push({
            path: "/tenderTerminationDetail",
            query: {
              id: this.multipleSelection[0].id,
              controllerFlag: "update"
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },

    /**
     * 点击删除按钮
     * @author 滕威
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 记录专家状态判断是否能删除
          var count = 0;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 不是自行组织
          if (tenderMethod && tenderMethod === "1" && tenderCorpFlag === "01") {
            // 提示
            this.$alert("该项目为委托招标请联系招标代理做删除操作。", "warning");
            return;
          }
          // 判断状态为通过或提交
          if (this.multipleSelection[0].state === "tj" || this.multipleSelection[0].state === "tg") {
            // 提示
            this.$alert("选中数据存在已提交或通过的终止申请，不能删除！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 发起请求，获取结果集
            fun_PostAction("/tenderTermination/delete", {
              id: id,
              code: this.multipleSelection[0].bidSectionCode
            }).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 查询列表
                this.fun_GetList();
                // 提示删除成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },

    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },

    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 传递参数
      let obj = {
        id: e.val.id,
        controllerFlag: "detail"
      }
      // 签章状态
      if (e.val.tenderSignedState) {
        // 修改参数
        obj = {
          id: e.val.id,
          isTenderSignature: "1",
          controllerFlag: "detail"
        }
      }
      // 跳转路由
      this.$router.push({
        path: "/tenderTerminationDetail",
        query: obj
      });
    },

    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 下拉框选择事件
     * @params e 选中的vlaue
     * @author 滕威
     */
     fun_GetSelectVal(e, field) {
      this.form[field] = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
